<template>
  <roe-error-message :field="design.employer_match_dollar_maximum">
    <roe-radio-input
      v-model="design.$model.employer_match_dollar_maximum"
      @change="resetAttributes(design, 'employer_match_dollar_maximum')"
    ></roe-radio-input>
  </roe-error-message>
</template>

<script>
import RoeErrorMessage from "@/components/_shared/inputs/ErrorMessage";
import ResetDesignAttributesMixin from "@/components/_shared/inputs/design/_mixins/ResetDesignAttributesMixin";
import RoeRadioInput from "@/components/_shared/inputs/RadioInput";
export default {
  name: "RoeEmployerMatchDollarLimitRadio",
  mixins: [ResetDesignAttributesMixin],
  components: { RoeRadioInput, RoeErrorMessage },
  props: {
    design: Object
  }
};
</script>
